// extracted by mini-css-extract-plugin
export var Category = "style-module--Category--29fa3";
export var Links = "style-module--Links--50c44";
export var Service = "style-module--Service--c28d7";
export var ServiceDetails = "style-module--ServiceDetails--dda17";
export var ServiceImage = "style-module--ServiceImage--d924f";
export var ServiceImageWrapper = "style-module--ServiceImageWrapper--abc7a";
export var Title = "style-module--Title--97a09";